import CourseCategoryTeaser from '@uikit/components/CourseCategoryTeaser/CourseCategoryTeaser';
import CourseCategoryTeaserGrid from '@uikit/components/CourseCategoryTeaserGrid/CourseCategoryTeaserGrid';
import type { CourseCategoryTeasersProps } from './types';

const CourseCategoryTeasers = ({ categories }: CourseCategoryTeasersProps) => {
  return (
    <CourseCategoryTeaserGrid>
      {categories
        ?.filter(({ courseLinks }) => courseLinks.length)
        .map(({ description, id, courseLinks, title, image, path }) => (
          <CourseCategoryTeaser
            key={id}
            courseAmount={courseLinks.length}
            description={description.replace(/\n.*/gm, '')}
            title={title}
            image={image}
            path={path}
          />
        ))}
    </CourseCategoryTeaserGrid>
  );
};

export default CourseCategoryTeasers;
